<script>
    import Button from "@smui/button/Button.svelte";

    import Select, { Option } from "@smui/select";
    import Textfield from "@smui/textfield";
    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import title from "../../components/title";

    import { post } from "../../http";
    import { getObject, setObject } from "../../session";

    export let location;

    let selectedProvince,
        selectedCity,
        selectedDistrict = "";
    let address = "";

    let provinces = [],
        cities = [],
        districts = [];

    $: selectedProvince && loadCity();
    $: selectedCity && loadDistrict();

    function loadCity() {
        cities = [];
        districts = [];
        selectedDistrict = "";
        post("/api/destination_city", { province: selectedProvince }).then(
            (resp) => {
                if (resp.status == 0) cities = resp.data;
            }
        );
    }

    function loadDistrict() {
        districts = [];
        post("/api/destination_district", {
            province: selectedProvince,
            city: selectedCity,
        }).then((resp) => {
            if (resp.status == 0) districts = resp.data;
        });
    }

    function next() {
        const order = getObject("order");
        order["recipient_address"] = address;
        order["recipient_province"] = selectedProvince;
        order["recipient_city"] = selectedCity;
        order["recipient_district"] = selectedDistrict;
        order["recipient_zipcode"] = "-";

        const district = districts.find((v) => v.name == selectedDistrict);
        order["destination_code"] = district.code;
        setObject("order", order);
        navigate("/package");
    }

    onMount(() => {
        title.set("Alamat Tujuan");
        post("/api/destination_province").then((resp) => {
            if (resp.status == 0) provinces = resp.data;
        });
    });
</script>

<style lang="scss">
</style>

<div class="content padding-top">
    <Select
        bind:value={selectedProvince}
        variant="outlined"
        label="Provinsi"
        enhanced>
        {#each provinces as p}
            <Option value={p.name} selected={selectedProvince === p.name}>
                {p.name}
            </Option>
        {/each}
    </Select>

    {#if cities.length > 0}
        <Select
            bind:value={selectedCity}
            variant="outlined"
            label="Kota/Kabupaten"
            enhanced>
            {#each cities as c}
                <Option value={c.name} selected={selectedCity === c.name}>
                    {c.name}
                </Option>
            {/each}
        </Select>
    {/if}
    {#if districts.length > 0}
        <Select
            bind:value={selectedDistrict}
            variant="outlined"
            label="Kecamatan/Kelurahan"
            enhanced>
            {#each districts as s}
                <Option value={s.name} selected={selectedDistrict === s.name}>
                    {s.name}
                </Option>
            {/each}
        </Select>
    {/if}
    {#if selectedDistrict != ''}
        {#if selectedDistrict.code != ''}
            <Textfield
                textarea
                bind:value={address}
                label="Alamat Lengkap"
                input$rows="4"
                input$placeholder="Masukkan nama jalan/gedung/apartemen, no rumah, RT/RW, dan alamat lainnya" />
        {/if}
        {#if address.length > 10}
            <Button on:click={next} variant="unelevated" class="rounded">
                Lanjutkan
            </Button>
        {/if}
    {/if}
</div>
